import { Component, OnInit } from '@angular/core';

import axios from "src/app/Service/axios";

import Chart from 'chart.js/auto';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import { Observable, map, of } from 'rxjs';

@Component({

  selector: 'app-route-dashboard',

  templateUrl: './route-dashboard.component.html',

  styleUrls: ['./route-dashboard.component.css']

})

export class RouteDashboardComponent implements OnInit {

  list_ServicesNotPerformed = [];

  options!: Observable<any>;

  CHART_COLORS3: any = {

    green: 'rgb(111, 255, 111)',

    purple: 'rgb(255, 153, 204)',

    blue: 'rgb(29, 179, 214)',

    orange: 'rgb(45, 103, 103)',

    yellow: 'rgb(251, 101, 150)',

    red: 'rgb(36, 123, 46)',

    grey: 'rgb(103, 13, 183)',

  };

  constructor(

    private Notification: NotificationService,

    private otherService: OtherService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.initialCharts()

  }

  async initialCharts() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    this.getToDaySchdeule(model);

    this.getServicesNotPerformed(model);

    this.getServicesByDriver(model);

    this.getServicesByRoute(model);

    this.getStationsByRoute(model);

    this.loadTree('Route_Dashboard_Tree_ServicesProgram');

    this.otherService.nonespinner()

  }

  async getToDaySchdeule(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_ToDaySchdeule`, model)).data.toString()));

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },

      ],

    } as any;

    new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart1") as any;

    chartEl.height = 200;

  }

  async getServicesNotPerformed(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_ServicesNotPerformed`, model)).data.toString()));

    this.list_ServicesNotPerformed = res;

  }

  async getServicesByDriver(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_NumberOfServicesByDriver`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async getServicesByRoute(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_NumberOfServicesByRoute`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart3') as any;

    new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async getStationsByRoute(model: any) {

    let res = JSON.parse(((await axios.post(`Route_Dashboard_NumberOfStationsByRoute`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart4') as any;

    new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });

  }

  async loadTree(api: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    this.otherService.Showspinner();

    const resp = await axios.post(`${api}`, model);

    this.otherService.nonespinner();

    this.options = of(resp.data)

      .pipe(

        map((data: any) => {

          let res = JSON.parse(data.toString());

          let not = 0;

          res.children.forEach((element: any) => {

            not += element.children.length

          });

          if (not > 50) {

            let can = document.getElementById('totalVehicles') as HTMLElement;

            can.style.height = '700px'

          }

          res.children.forEach(function (datum: any, index: number) {

            index % 1 === 0 && (datum.collapsed = true);

          });

          return {

            tooltip: {

              trigger: 'item',

              triggerOn: 'mousemove',

              responsive: true,

              textStyle: {

                color: '#000',

                fontFamily: 'vazir',

                fontSize: 12

              },

              formatter: function (params: any) {

                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`

              }

            },

            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }


}
